import { createAction, props } from '@ngrx/store';
import { DataState } from './data.selectors';

export const resetDataState = createAction(
  '[Data State] Reset Data State'
);

export const setActiveAuction = createAction(
  '[Data State] Set Active Auction',
  props<{ activeAuction: DataState['activeAuction'] }>()
);

export const setCurrentBlock = createAction(
  '[Data State] Set Current Block',
  props<{ currentBlock: DataState['currentBlock'] }>()
);
